import React, { useEffect, useState } from 'react';
import './EcosystemHero.css';

const EcosystemHero = () => {
  const [isVisible, setIsVisible] = useState(false);

  const heroMetrics = [
    { value: '4+', label: 'Integrated products' },
    { value: '24/7', label: 'Operational coverage' },
    { value: 'Enterprise', label: 'Security-first architecture' }
  ];

  const trustSignals = [
    'Mobile + Web + CRM + Experiences',
    'Built for municipalities, enterprises, and operators',
    'API-ready foundation for long-term scale'
  ];

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section
      id="ecosystem-hero"
      className={`ecosystem-hero ${isVisible ? 'fade-in' : ''}`}
      aria-labelledby="ecosystem-hero-title"
    >
      <div className="hero-gradient-bg">
        <div className="hero-content-container">
          <p className="hero-eyebrow">ZoneZapp Enterprise Platform</p>

          {/* Main Headline */}
          <div className="hero-headline">
            <h1 id="ecosystem-hero-title" className="hero-title">
              <span className="gradient-text">ZoneZapp</span> Ecosystem
            </h1>
            <h2 className="hero-subtitle">
              Beyond an App. A Strategic Digital Platform for Connected Communities.
            </h2>
            <p className="hero-description">
              Unify operations, engagement, and local intelligence across one ecosystem.
              ZoneZapp helps public and private organizations launch measurable community outcomes with enterprise-grade reliability.
            </p>
          </div>

          {/* CTA Buttons */}
          <div className="hero-cta-group">
            <a href="#products" className="cta-primary" aria-label="Explore ZoneZapp platform products">
              <span>Explore Platform</span>
              <i className="fas fa-arrow-right"></i>
            </a>
            {/* Client Login hidden temporarily */}
          </div>

          <ul className="hero-trust-strip" aria-label="Platform capabilities">
            {trustSignals.map((signal) => (
              <li key={signal}>{signal}</li>
            ))}
          </ul>

          {/* Floating Stats */}
          <dl className="hero-stats">
            {heroMetrics.map((metric) => (
              <div key={metric.label} className="stat-card">
                <dt className="stat-number">{metric.value}</dt>
                <dd className="stat-label">{metric.label}</dd>
              </div>
            ))}
          </dl>
        </div>

        {/* Animated Background Elements */}
        <div className="hero-bg-elements">
          <div className="floating-orb orb-1"></div>
          <div className="floating-orb orb-2"></div>
          <div className="floating-orb orb-3"></div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="scroll-indicator">
        <div className="scroll-mouse">
          <div className="scroll-wheel"></div>
        </div>
        <p>Scroll to explore</p>
      </div>
    </section>
  );
};

export default EcosystemHero;
